import { Navigate } from 'react-router-dom';
import useModuleAccess from '../../hooks/useModuleAccess';

/**
 * RouteGuard — route-level access checkpoint for module-gated screens.
 *
 * Checks has_module_access() before the guarded screen mounts.
 * - While the RPC is in flight: renders a neutral loading indicator so the
 *   guarded screen never flashes for an unauthorized user.
 * - On deny: renders a plain access-denied message without mounting children.
 * - On allow: renders children unchanged — no visual difference for
 *   authorized users.
 *
 * This is a front-door checkpoint that sits in front of the existing RLS gate
 * on the underlying data; it does not replace that gate.
 */
function RouteGuard({ module, action = 'view', entityId = null, groupId = null, isUser = false, children }) {
    const { allowed, loading } = useModuleAccess(module, action, entityId, groupId);

    if (loading) return <div className="p-8 text-center text-gray-400">Loading…</div>;
    if (!allowed) {
        return isUser
            ? <div role="alert" className="p-8 text-center text-gray-600">You don't have access.</div>
            : <Navigate to="/dashboard" replace />;
    }
    return children;
}

export default RouteGuard;
